import {useReducer, useEffect} from "react"
import {StProjectsContext} from "../contexts/StProjectsContext"
import stProjectsReducer from "../reducers/stProjectsReducer"

const initialState = {
    isModal: false,
    isConfirmationModal: {
        modal: false,
        id: null,
        action: null
    },
    tab: "my-projects",
    page: 1,
    projectID: null,
}

export default function StProjectsProvider({children}) {
    const [stProjectsContext, setStProjectsAction] = useReducer(
        stProjectsReducer,
        initialState,
    )

    useEffect(() => {
        if (stProjectsContext) {
            localStorage.setItem("stProjectsContext", JSON.stringify(stProjectsContext))
        } else {
            localStorage.removeItem("stProjectsContext")
        }
    }, [stProjectsContext])

    return (
        <StProjectsContext.Provider value={{stProjectsContext, setStProjectsAction}}>
            {children}
        </StProjectsContext.Provider>
    )
}